import { postionsConstants } from '../../constants/position';
import { reportConstants } from '../../constants/reports';
import { DevicesPlatformType } from './types/player-session-types';

const sessionsListMap = [
	{
		label: reportConstants.REPORT_SESSION_ID,
		key: reportConstants.COLUMN_SESSION_ID,
	},
	{
		label: reportConstants.REPORT_PLAYER_ID,
		key: reportConstants.COLUMN_PLAYER_ID,
	},
	{
		label: reportConstants.REPORT_EXT_PLAYER_ID,
		key: reportConstants.COLUMN_EXT_PLAYER_ID,
	},
	{
		label: reportConstants.REPORT_PARTNER,
		key: reportConstants.COLUMN_PARTNER,
	},
	{ label: reportConstants.REPORT_SKIN, key: reportConstants.COLUMN_SKIN },
	{
		label: reportConstants.REPORT_PROVIDER,
		key: reportConstants.COLUMN_GAME_PROVIDER_NAME,
	},
	{ label: reportConstants.REPORT_GAME, key: reportConstants.COLUMN_GAME },
	{ label: reportConstants.REPORT_DEVICE, key: reportConstants.COLUMN_DEVICE, position: postionsConstants.CENTAR },
	{ label: reportConstants.REPORT_SOURCE, key: reportConstants.COLUMN_SOURCE, position: postionsConstants.CENTAR },
	{ label: reportConstants.REPORT_TYPE, key: reportConstants.COLUMN_TYPE, position: postionsConstants.CENTAR },
	{ label: reportConstants.REPORT_STATUS, key: reportConstants.COLUMN_STATUS, position: postionsConstants.CENTAR },
	{ label: reportConstants.REPORT_BETS, key: reportConstants.COLUMN_NRHANDS, position: postionsConstants.CENTAR },
	{
		label: reportConstants.REPORT_CURRENCY,
		key: reportConstants.COLUMN_CURRENCY,
	},
	{
		label: reportConstants.REPORT_BET_AMOUNT,
		key: reportConstants.COLUMN_BET_AMOUNT,
		position: postionsConstants.RIGHT,
	},
	{ label: reportConstants.REPORT_GGR, key: reportConstants.COLUMN_GGR, position: postionsConstants.RIGHT },
	{
		label: reportConstants.REPORT_BONUS_USED,
		key: reportConstants.COLUMN_BONUS_USED,
		position: postionsConstants.RIGHT,
	},
	{ label: reportConstants.REPORT_WRB, key: reportConstants.COLUMN_WRB },
	{
		label: reportConstants.REPORT_AAMS_TICKET_ID,
		key: reportConstants.COLUMN_AAMS_TICKET_ID,
	},
	{
		label: reportConstants.REPORT_TP_SESSION_ID,
		key: reportConstants.COLUMN_TP_SESSION_ID,
	},
	{ label: reportConstants.REPORT_IP, key: reportConstants.COLUMN_IP },
	{
		label: reportConstants.REPORT_SESSION_START,
		key: reportConstants.COLUMN_SESSION_START,
	},
	{
		label: reportConstants.REPORT_SESSION_END,
		key: reportConstants.COLUMN_SESSION_END,
	},
];

const columnFormatter = {
	session_id: 'value',
	player_id: 'value',
	external_player_id: 'value',
	partner: 'value',
	skin: 'value',
	game_provider_name: 'value',
	game_name: 'value',
	device: 'value',
	widget: 'value',
	session_type: 'value',
	session_status: 'value',
	nrhands: 'value',
	bet: 'cents',
	ggr: 'cents',
	wrb: 'value',
	bonus_used: 'cents',
	aams_ticket_id: 'value',
	thirdparty_session_id: 'value',
	ip: 'value',
	session_start: 'value',
	session_end: 'value',
};

const devicesMap: DevicesPlatformType = {
	'10': 'android/unix browser',
	'11': 'MacOS browser',
	'12': 'MS Windows browser',
	'14': 'other browser',
	'30': 'android/unix browser',
	'31': 'iOS browser',
	'32': 'MS Windows browser',
	'34': 'other browser',
	'40': 'android App',
	'41': 'iOS mobile App',
	'51': 'iOS tablet App',
};

export { sessionsListMap, columnFormatter, devicesMap };
